import React, { useContext, useState, useEffect } from "react";
import PropTypes from 'prop-types';
import "./Header.scss";
import { AppContext } from 'src/App';
import { serviceError } from '../../constants/config';
import GoodMorningImage from '../../styles/images/Good-morning.svg';
import GoodAfternoonImage from '../../styles/images/good-afternoon.svg';
import GoodEveningImage from '../../styles/images/good-evening.svg';
import MenuImage from '../../styles/images/menu.svg';
import PearsonImage from '../../styles/images/Pearson-mobilelogo.svg';
import SelectDropdown from '../userLanguage/userLanguage'
import { Button } from '@activehub/common-components-spa'
import { supportUrls } from "src/constants/supportUrlAH";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation } from "react-router-dom";

export function Header({
  headerDetails = {
    name: "Pearson",
    description: "pearson global gateway",
    welcome: "Welcome!"
  },
  headerImage = `${process.env.PUBLIC_URL}/images/Pearson-logo-desktop.svg`,
  ...restProps
}) {
  const props = { headerDetails, headerImage, ...restProps };
  const appContext = useContext(AppContext);
  const { selectedSpaId, activeHubInfo, setToast, defaultSpaId, entities } = appContext;
  const [messageCount, setMessageCount] = useState(0)
  const [expand, setExpand] = useState(true)
  const { isActiveHub } = activeHubInfo;
  const [headerImageLoaded, setHeaderImageLoaded] = useState(false);
  const isMobile = !useMediaQuery('(min-width:768px)');
  const {pathname}  = useLocation();
  const misRoutes = ["/mis-integration-v2"];

  function handleHeaderImageLoad() {
    if (!headerImageLoaded) {
      setHeaderImageLoaded(true);
    }
  }

  function handleBtnKeyDown(event) {
    event.preventDefault();
    if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") {
      toggleSideNav()
    }
  }
  function toggleSideNav() {
    if (expand) {
      document.getElementById("sidebar-container")?.classList.add("side-nav__exp");
    } else {
      document.getElementById("sidebar-container")?.classList.remove("side-nav__exp");
    }
    setExpand(!expand)
  }

  function keyPressed(event) {
    event.preventDefault();
    if (event.key === "Enter") {
      props.showDropDown();
    }
  }

  const handleSupportClick = (evt) => {
    evt.preventDefault();
    const commonHelpLink = "https://www.pearsonschoolsandfecolleges.co.uk/help/helphub?categoryBlog=05664d86-e5d6-4250-b970-69137b09f1d5";
    const misHelpLink = "https://www.pearsonschoolsandfecolleges.co.uk/help/helphub#misintegration";
    if(pathname.includes(misRoutes)){
      window.open(misHelpLink, "_blank");
    }else{
      window.open(commonHelpLink, "_blank");
    }
  }
  
  useEffect(() => {
    if (!(isActiveHub && window.USERPROFILE && window.USERPROFILE.firstName)) return;
    if (defaultSpaId === selectedSpaId && messageCount === 0) {
      setMessageCount(1)
      let today = new Date();
      let curHr = today.getHours();
      let greeting = '', toastImg = '';

      if (curHr < 12) {
        greeting = 'Good morning';
        toastImg = GoodMorningImage;
      } else if (curHr < 18) {
        greeting = 'Good afternoon';
        toastImg = GoodAfternoonImage;
      } else {
        greeting = 'Good evening';
        toastImg = GoodEveningImage;
      }
      setToast({
        title: '',
        msg: `${greeting} ${entities.decode(entities.decode(window.USERPROFILE.firstName))}`,
        styleClass: "greetings",
        status: 'inf',
        delay: 2000,
        autoHide: true,
        toastImg: `${toastImg}`,
        show: true
      });
    }

  }, [window.USERPROFILE, isActiveHub, selectedSpaId])

  return (
    <div className={`gwHeader ${isActiveHub && 'gwHeader__ahub'}`}>
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div className="gwHeaderLogo">
              <a href="#" onClick={handleBtnKeyDown} onKeyDown={handleBtnKeyDown}>
                <img
                  src={props.headerImage}
                  // title={props.headerDetails.description}
                  alt="Pearson Global Gateway"
                  onClick={(selectedSpaId !== serviceError) && props.handleHeaderClick}
                  className={`gwHeaderLogo__img gwHeaderLogo__${(headerImageLoaded) ? 'hide' : 'show mbnone'}`}
                />
                <img
                  src={props.headerDetails.headerImageUrl}
                  // title={props.headerDetails.description}
                  alt="Pearson Global Gateway"
                  onClick={(selectedSpaId !== serviceError) && props.handleHeaderClick}
                  onLoad={handleHeaderImageLoad}
                  className={`gwHeaderLogo__img gwHeaderLogo__${(headerImageLoaded) ? 'show' : 'hide'}`}
                />
                <img src={MenuImage} className="pr-3 d-xl-none" title="menu" alt="menu-icon" onClick={toggleSideNav} />
                <img src={PearsonImage} className="d-xl-none" title="Pearson global gateway" alt="Pearson Global Gateway" />
              </a>
            </div>

            {(props.showWelcomeMsg && !isActiveHub) &&
              <div className="gwHeaderLogo__note">
                <h1 className="gwHeaderLogo__notetxt">{props.headerDetails.welcome}</h1>
              </div>}
          </div>
          {/* <p style={{ userSelect: "none" }}>{props.headerDetails.welcome}</p> */}
          <div className="d-flex align-items-center">
            {!isActiveHub ?
              <div className="gwLanguage mr-lg-4 mr-md-4 mr-sm-2 mr-2">
                <SelectDropdown />
              </div> : <div className="gwhelp">
                {isMobile ? 
                <a href="https://www.pearsonschoolsandfecolleges.co.uk/help/helphub?categoryBlog=05664d86-e5d6-4250-b970-69137b09f1d5" className="material-icons gwhelp-icon"
                  rel="noopener noreferrer" target="_blank" onClick={handleSupportClick}>help_outline
                  <span className="screen-reader-only">Opens in a new window</span></a> 
              : 
              <Button  className="helpHub button__v2 button__v2__primary__bordered d-flex align-items-center mr-3" 
              onClick={handleSupportClick}
              ><span className="help-text"><img src={`${process.env.PUBLIC_URL}/images/help-hub.svg`} className="helpIcon mr-0" alt="Help hub icon" aria-hidden="true" /> HelpHub</span><span className="screen-reader-only">Opens in a new window</span></Button>
              }
                </div>}
             
            <div className="gwProfile">
              <ul>
                <li className="gwAvatar gwProfile__dropdownbtn">
                  <Button className={`gwAvatar__btn ${isActiveHub && 'active-hub'} m-0 p-0`}
                    aria-controls="user_menu"
                    value={props.userInitials}
                    onClick={props.showDropDown}
                    onKeyPress={keyPressed}
                    haspopup={true}
                  />
                  {/* {props.userDetails.avatar ? <img className="gwAvatar__image" src="images/icon-school-user.svg" alt="school user image" /> : */}

                  {/* <label title={props.userInitials} className="gwAvatar__text">{props.userInitials}</label> */}
                  {props.children}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  showDropDown: PropTypes.func.isRequired,
  userInitials: PropTypes.string,
  headerImage: PropTypes.string,
  headerDetails: PropTypes.object,
  handleHeaderClick: PropTypes.func,
  showWelcomeMsg: PropTypes.bool
}
